export const GOOGLE_DOCS_EXTENSIONS = ['DOC', 'DOCX', 'XLS', 'XLSX', 'PPT', 'PPTX', 'PDF'];
